import { createContext } from 'react';

export const cCurrencyCodeContext = createContext<string | null>(null);
